<div class="app-wrapper h-100">
  <router-outlet></router-outlet>
</div>